exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!./fonts.css"), "");

// module
exports.push([module.id, ".bg-primary,.btn-primary{background:#890000}.btn-primary{color:#fff}.btn-primary:hover{background:#700000}.navbar-primary{background:#890000;color:#fff}.login{margin:0;width:100%;text-align:center;position:relative;height:180px}.login img{position:absolute;left:43.3%;bottom:-100px;z-index:999}.motivacional{margin-top:25%}.motivacional p{font-size:1.1em;line-height:1.5em;font-weight:500}.app{margin-top:20px;margin-bottom:50px}.z-index-full{z-index:1031!important}.v--modal-box .title{padding:4px 16px;background:#700000;color:#fff;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./src/assets/css/container.less
// module id = 621
// module chunks = 7